import { Block } from '@/components/Block';
import { Page } from '@/config/track-config';
import { useScreenType } from '@/hooks/media';
import { TextLink } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import classNames from 'classnames';
import Link from 'next/link';

export function SectionWork() {
  const fm = useFm();
  const partnerLink =
    'https://docs.google.com/forms/d/e/1FAIpQLScHnOjQSJGo_90NMIYeMfSNQPH4igv3kNTQshWUV0vyFh-gkg/viewform';
  const buildLink = 'https://bybit-web3.github.io/getting-started';
  const { isMobile } = useScreenType();
  return (
    <Block className="work-wrap mt-16" title={fm('boostDappWithBybit')}>
      <div
        className={classNames([
          'flex justify-between',
          isMobile ? 'flex-col gap-4' : 'flex-row gap-8',
        ])}
      >
        <div
          className={classNames([
            'bg-area rounded flex flex-col',
            isMobile ? 'p-4 w-full' : 'px-8 py-6 w-1/2',
          ])}
        >
          <h4 className="text-sm md:text-base font-semibold">
            {fm('partnerWithUs')}
          </h4>
          <div className="flex flex-col justify-between mt-4 !md:mt-6 gap-6 flex-1">
            <div>
              <h2 className="text-2xl md:text-4xl font-semibold">
                {fm('bybitWeb3Wallet')}
              </h2>
              <p className="text-gray1 text-sm md:text-lg font-normal mt-4 !md:mt-6">
                {fm('submitDAppFeatSpot')}{' '}
              </p>
            </div>
            <Link
              href={partnerLink}
              target="_blank"
              data-spm-even="Web3UserClick"
              data-spm-data={JSON.stringify({
                page_name: Page.AirdropArcadeHome,
                button_name: 'SubmitDapps',
              })}
            >
              <TextLink>{fm('submitDapps')}</TextLink>
            </Link>
          </div>
        </div>
        <div
          className={classNames([
            'bg-area rounded flex flex-col',
            isMobile ? 'p-4 w-full' : 'px-8 py-6 w-1/2',
          ])}
        >
          <h4 className="text-sm md:text-base font-semibold">
            {fm('buildWithUs')}
          </h4>
          <div className="flex flex-col justify-between mt-4 !md:mt-6 gap-6 flex-1">
            <div>
              <h2 className="text-2xl md:text-4xl font-semibold">
                {fm('boostYourDApps')}
              </h2>
              <p className="text-gray1 text-sm md:text-lg font-normal mt-4 !md:mt-6">
                {fm('officialTechDoc')}
              </p>
            </div>
            <Link
              href={buildLink}
              target="_blank"
              data-spm-even="Web3UserClick"
              data-spm-data={JSON.stringify({
                page_name: Page.AirdropArcadeHome,
                button_name: 'DeveloperDoc',
              })}
            >
              <TextLink>{fm('developterDoc')}</TextLink>
            </Link>
          </div>
        </div>
      </div>
    </Block>
  );
}
